<template>
    <div>
        <b-table
            :items="items"
            :fields="fields"
            responsive
            class="scroll-bar-mkt"
        >
        <template #cell(job_name)="row">
            <h5>{{ row.item.job_name }}</h5>
            <div class="text-muted">HUB-{{ row.item.id }}</div>
        </template>
        <template #cell(status)="row">
            <b-badge
                :variant="getStatusBadgeVariant(row.item.status)"
                class="my-2"
            >
                {{ getStatusBadgeText(row.item.status) }}
            </b-badge>
        </template>
        <template #cell(show_details)="row">
            <b-button
            size="sm"
            @click="row.toggleDetails"
            class="my-1 text-muted"
            >
            <i class="fa fa-eye"></i> {{ row.detailsShowing ? "ซ่อน" : "ดูเพิ่มเติม" }}
            </b-button>
        </template>
        <template #row-details="row">
            <hr class="border-dashed-spacing mt-0 mb-4" />
            <CardLocation 
                :item="row.item" 
                @confirmJob="confirmJob"
            />
        </template>
        </b-table>
        <div class="mt-3">
            <b-pagination 
                :total-rows="search.totalItem"
                :current-page="search.page"
                :per-page="search.perPage"
                :value="search.page"
                @input="$emit('changePage', $event)"
                align="center"
            >
            </b-pagination>
        </div>   
    </div>
</template>

<script>
import jobServices from "@/api/job.service.js";
import CardLocation from '@/components/Home/CardLocation.vue'
import { getStatusBadgeVariant, getStatusBadgeText } from "@/util/constants.js"

export default {
    components: {
        CardLocation
    },
    props: {
        items: {
            type: Array
        },
        search: {
            type: Object
        }
    },
    data() {
        return {
            getStatusBadgeVariant,
            getStatusBadgeText,
            fields: [
                {
                    key: "job_name",
                    label: "ชื่องาน/รหัสงาน",
                },
                {
                    key: "status",
                    label: "สถานะ",
                    class: 'text-center'
                },
                {
                    key: "show_details",
                    label: "การจัดการ",
                },
            ],
        }
    },
    methods:{
        async confirmJob(JobId, JobStatus) {
            if (JobStatus === "wait") {
                try {
                await jobServices.confirmDriverJob({
                    job_id: JobId,
                    status: "inprogress",
                });
                } catch (err) {
                    console.log("error confirmJob", err);
                    alert("เกิดข้อผิดพลาด");
                }
            }
            this.$router.push({
                name: "workAfter",
                params: { id: JobId },
            });
        },
    }
}
</script>
